import { Breadcrumb, Button, Col, message, Row, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDealer } from "../../../../tools/api";
import { useTranslation } from "react-i18next";
import Loading from "../../../auxiliary/loader/loading";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import { complexDigitToman, isEmpty } from "../../../../tools/tools";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { switchPlanID } from "../../../../tools/services";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const PrefactorPayBill = () => {
	const [t] = useTranslation("global");
	const { callBackBillingToNeginWallet } = useDealer();
	const [searchParam] = useSearchParams();
	const nav = useNavigate();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();

	const [wallet, setWallet] = useState(0);
	const location = useLocation();
	const [openIncress, setOpenIncress] = useState();
	const [totalPrice, setTotalPrice] = useState(0);
	const [localInvoiceId, setLocalInvoiceId] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [totalPriceWallet, setTotalPriceWallet] = useState(0);

	const [messageApi, contextHolder] = message.useMessage();

	const bankRef = useRef("");

	console.log(location?.state);

	useEffect(() => {
		try {
			if (!isEmpty(searchParam.get("localInvoiceId"))) {
				const getLocalInvoiceID = searchParam.get("localInvoiceId");
				setLocalInvoiceId(getLocalInvoiceID);
				setOpenIncress(true);
				location.state = formData?.another?.dcCharge;
			}
		} catch (error) {
			console.error(error);
		}
	}, []);

	useEffect(() => {
		try {
			setWallet(formData?.another?._currentUser?.walletAmount);
		} catch (error) {
			console.error(error);
		}
	}, [formData?.another?._currentUser?.walletAmount]);

	useEffect(() => {
		calcPrice();
	}, []);

	const calcPrice = () => {
		try {
			let chargeAmount = location?.state?.depositAmount;

			// setTotalPrice(chargeAmount + taxPrice);
			setTotalPrice(chargeAmount);
			setTotalPriceWallet(chargeAmount);
		} catch (error) {
			console.error(error);
		}
	};

	const handleCallBackCharge = (value) => {
		try {
			if (value?.length > 0) {
				dispatch(globalValue({ dcCharge: { ...location?.state } }));
				bankRef.current.innerHTML = value;
				document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
			} else {
				setLocalInvoiceId("");
				setOpenIncress(false);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			if (wallet - totalPriceWallet >= 0) {
				let payload = {
					paybillid: location?.state?.payBillId,
				};

				let response = await callBackBillingToNeginWallet(payload);
				if (response) {
					nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Final, { state: { ...response } });
				}
			} else {
				messageApi.open({
					type: "error",
					content: "موجودی کیف پول کافی نمی باشد.",
				});
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<>
			<div className="container-main container-sp">
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("payBill.title") }]} />
					<div className="title-page">
						<h3>{t("payBill.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											items={[
												{
													title: "صورتحساب",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "رسید",
												},
											]}
										/>
									</div>
								</div>
								<div className="g-prefactor">
									<div className="holder-row-prefactor">
										<Row gutter={16}>
											<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
												<div className="for-pay-client">
													<h3>صورت حساب مشتری</h3>
													<div className="holder-box">
														<div className="holder-simcard">
															<div className="holder-list-msisdn">
																<div className="item">
																	<div className="row-item">
																		<div className="holder-icon">
																			<i className="icon-simcard"></i>
																		</div>
																		<div className="holder-text">
																			<h4>
																				ﺳﯿﻢ‌ﮐﺎﺭﺕ دائمی ﺑﺎ ﺷﻤﺎﺭﻩ <span dir="ltr">{location?.state?.msisdn}</span>
																			</h4>
																			<p></p>
																		</div>
																		<div className="holder-option"></div>
																	</div>
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<div className="list-item">
																<div className="item">
																	<div className="label">مبلغ صورتحساب:</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(location?.state?.depositAmount)}</span> تومان
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Col>
											<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
												<div className="for-pay-agent">
													<h3>صورت حساب فروشنده</h3>
													<div className="holder-box">
														<div className="holder-list-pay">
															<ul>
																<li>
																	<div className="label">مبلغ بدهی</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(location?.state?.depositAmount)}</span> <small>تومان</small>
																	</div>
																</li>
																<li>
																	<div className="label">مبلغ قابل دریافت از مشتری</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(totalPrice)}</span> تومان
																	</div>
																</li>

																<li>
																	<div className="label">مبلغ برداشت از کیف پول</div>
																	<div className="value">
																		<span dir="ltr">
																			{/* {complexDigitToman(totalPrice)} */}
																			{complexDigitToman(totalPriceWallet)}
																		</span>{" "}
																		تومان
																	</div>
																</li>
															</ul>
															{wallet - totalPriceWallet >= 0 ? (
																<div className="hold-message success">
																	<p>این مبلغ از کیف پول شما برداشت می‌شود</p>
																	<h3>
																		{" "}
																		<span dir="ltr">
																			{/* {complexDigitToman(Math.abs(totalPrice))} */}
																			{complexDigitToman(totalPriceWallet)}
																		</span>{" "}
																		تومان
																	</h3>
																</div>
															) : (
																<div className="hold-message error">
																	<div className="row-message">
																		<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																					<div className="label">کسری اعتبار: </div>
																					<div className="value">
																						<span dir="ltr">
																							{/* {complexDigitToman(
                                                Math.abs(totalPrice - wallet)
                                              )} */}
																							{complexDigitToman(wallet - totalPriceWallet)}
																						</span>{" "}
																						تومان
																					</div>
																				</li>
																			</ul>
																		</div>
																		<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																					افزایش اعتبار
																				</Button>
																			</div>
																		</div>
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button type="primary" className="btn-normal btn-aptel" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal"
										onClick={() => nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill)}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			{contextHolder}

			<IncressCharge
				open={openIncress}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_DC}
				msisdn={formData?.another?._currentUser?.telnoone}
				price={Math.abs(wallet - totalPriceWallet)}
				callback={handleCallBackCharge}
				localInvoiceId={localInvoiceId}
			/>

			<Loading isOpen={isLoading} />
			<div ref={bankRef}></div>
		</>
	);
};

export default PrefactorPayBill;
